/**
 * Branded route-transition skeleton — shown while a lazy-loaded page chunk
 * is being fetched. Mimics the standard AppLayout page shell
 * (PageHeader + content grid) so route swaps feel instant.
 * Phase 1.18 — Frontend code-splitting.
 */
export default function RouteSkeleton() {
  return (
    <div
      data-testid="route-skeleton"
      className="min-h-[60vh] w-full animate-pulse"
    >
      {/* Header stripe — mirrors PageHeader.jsx */}
      <div className="px-4 lg:px-8 py-6 border-b border-white/5">
        <div className="h-3 w-16 bg-brand-red/40 rounded-sm mb-4" />
        <div className="h-8 w-56 bg-white/10 rounded-sm" />
        <div className="mt-3 h-3 w-32 bg-white/5 rounded-sm" />
      </div>
      {/* Body — filter row + content blocks */}
      <div className="p-4 lg:p-8 space-y-4">
        <div className="flex flex-wrap gap-3">
          <div className="h-9 w-40 bg-white/5 rounded-sm" />
          <div className="h-9 w-40 bg-white/5 rounded-sm" />
          <div className="h-9 w-40 bg-white/5 rounded-sm" />
        </div>
        <div className="grid gap-3">
          <div className="h-16 bg-white/5 rounded-sm" />
          <div className="h-16 bg-white/[0.04] rounded-sm" />
          <div className="h-16 bg-white/[0.03] rounded-sm" />
          <div className="h-16 bg-white/[0.02] rounded-sm" />
        </div>
      </div>
    </div>
  );
}
